import { DailyDeals } from 'components/main-page/home-page/daily-deals/DailyDeals'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_DAILY_DEALS } from 'services/api-home-page/apiDailyDeals'
import { convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    is_show: false,
    daily_deal: {
        title: null,
        title_image_url: null,
        banners: [
            {
                image_url: null,
                url: null,
            },
        ],
    },
}

const GET_FIELD_NAME = {
    title: 'Text title',
    banners: 'Mini banner item',
}

const GET_ITEM_FIELD_NAME = {
    image_url: 'Mini banner',
    url: 'Link direction',
}

const FIELD_NAME_DETAIL = {
    ...GET_FIELD_NAME,
    title_image_url: 'Image title',
}

export const DailyDealsContainer = () => {
    const [reload, setReload] = useState(false)
    const [dailyDealsDetail, setDailyDealsDetail] = useState(INITIAL_STATE)
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [errorForm, setErrorForm] = useState({})
    const [errorMessage, setErrorMessage] = useState({})
    const { fetching: getDailyDealsDetail, isLoading } = useFetch(API_DAILY_DEALS.DETAIL)
    const { fetching: getUrlImageDailyDeals } = useFetch(API_DAILY_DEALS.URL_IMAGE_DAILY_DEALS)
    const { fetching: updateDailyDeals, isLoading: isUpdating } = useFetch(API_DAILY_DEALS.UPDATE)

    const onChangeForm = (e) => {
        const { name, value, checked } = e
        let newData
        if (checked === undefined) {
            newData = { daily_deal: { ...dailyDealsDetail?.daily_deal, [name]: value } }
        } else {
            newData = { [name]: checked }
        }
        setDailyDealsDetail({ ...dailyDealsDetail, ...newData })
    }

    const setUploadDailyDealsImages = async (filesName, uploadDetail) => {
        let newImageTitle = dailyDealsDetail?.daily_deal?.title_image_url
        const newMiniBanners = [...dailyDealsDetail?.daily_deal?.banners]

        try {
            const s3Urls = await getUrlImageDailyDeals({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                if (uploadDetail[i]?.type === 'banner') {
                    newMiniBanners[uploadDetail[i]?.index] = {
                        ...newMiniBanners[uploadDetail[i]?.index],
                        [uploadDetail[i]?.key]: `${item?.url}${item?.fields?.key}`,
                    }
                } else {
                    newImageTitle = `${item?.url}${item?.fields?.key}`
                }
            })
            await Promise.all(apiS3list)
            const newDetail = {
                ...dailyDealsDetail,
                daily_deal: {
                    ...dailyDealsDetail?.daily_deal,
                    title_image_url: newImageTitle,
                    banners: newMiniBanners,
                },
            }
            onSave(newDetail)
        } catch (err) {
            console.error(err)
        }

        setIsLoadingUpload(false)
    }

    const validateForm = () => {
        const validateMiniBanners = () => {
            const result = []
            dailyDealsDetail?.daily_deal?.banners?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            const dailyDeals = dailyDealsDetail?.daily_deal
            Object.keys(dailyDealsDetail?.daily_deal).forEach((key) => {
                if (GET_FIELD_NAME[key] && (!dailyDeals[key] || dailyDeals[key]?.length === 0)) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (key === 'banners' && validateMiniBanners()?.length) {
                    errors['banners_detail'] = validateMiniBanners()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(async () => {
            const dailyDealsImages = [
                dailyDealsDetail?.daily_deal?.title_image_url,
                ...dailyDealsDetail?.daily_deal?.banners,
            ]
            const uploadDetail = []
            const filesName = []

            const mapImages = (name, file, index, key, type = 'banner') => {
                filesName.push(name?.replace(/\s/g, ''))
                uploadDetail.push({ file, type, key, index })
            }

            dailyDealsImages.map((item, index) => {
                if (item?.name) {
                    mapImages(item?.name, item?.file, 0, 'title_image_url', 'image-title')
                }

                if (item?.image_url?.name) {
                    mapImages(item?.image_url?.name, item?.image_url?.file, index - 1, 'image_url')
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadDailyDealsImages(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...dailyDealsDetail }) => {
        const newPayload = {
            ...payload,
            daily_deal: {
                ...payload?.daily_deal,
                banners: payload?.daily_deal?.banners?.map((item, index) => {
                    return {
                        ...item,
                        sequence: index,
                    }
                }),
            },
        }
        updateDailyDeals(newPayload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Daily Deals Updated !',
                })
            })
            .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL, GET_ITEM_FIELD_NAME)))
    }

    useEffect(() => {
        getDailyDealsDetail().then((response) => setDailyDealsDetail({ ...response?.data }))
    }, [reload])

    const props = {
        isShow: dailyDealsDetail?.is_show,
        sectionProps: {
            dailyDealsDetail: dailyDealsDetail?.daily_deal,
            onChangeForm,
            errorForm: { daily_deal: { ...errorForm, ...errorMessage } },
        },
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <DailyDeals {...props} />
}
